import { FileUpload } from "components/RFQ/FileUpload";
import { RfxContext } from "newui/features/Rfx/context/RfxContext";
import { useField } from "formik";
import { useContext } from "react";
import { cn } from "utils/helpers";
import { AcceptedFileTypesForRFx } from "utils/rfxLargeFileUploadHelper";
import { removeProgressFromUploading } from "utils/rfxLargeFileUploadHelper";
import { BidderQuestionnaireHeader } from "./BidderQuestionnaireHeader";
import { FILE_UPLOAD_TYPES, fileUpload } from "newui/components/FileUpload";
import { useRfxSubmissionData } from "newui/features/Rfx/data-provider/RfxSubmissionDataProvider";
export const FileInputQuestionnaire = ({
	className,
	question,
	required,
	fieldValue,
	singleFile,
	rfxInviteId,
	...props
}) => {
	const [field, meta] = useField(props);
	const { error } = meta;
	const { rfxId } = useRfxSubmissionData();
	const { setUploadInProgresses } = useContext(RfxContext);

	const existingFiles = field.value || [];

	const handleFileUploadComplete = () => {
		setUploadInProgresses((prev) => removeProgressFromUploading(prev, true));
	};

	const onDeleteFile = async (file) => {
		return fileUpload.util.deleteFileUpload(
			file,
			FILE_UPLOAD_TYPES.RETURNABLE_SCHEDULE_QUESTIONNAIRE_FILE_RESPONSE
		);
	};

	return (
		<div
			className={cn(className)}
			{...props}
		>
			<BidderQuestionnaireHeader
				question={question}
				required={required}
				error={error}
				touchedField={props?.touchedField}
			/>
			<div>
				<FileUpload
					type="file"
					className="my-4 w-full"
					types={AcceptedFileTypesForRFx}
					defaultFileName="Document"
					isDisabled={true}
					maxFileSize={100}
					singleFile={singleFile}
					multiple={true}
					existingFiles={existingFiles}
					handleFileUploadComplete={handleFileUploadComplete}
					fileExtraData={{
						model:
							FILE_UPLOAD_TYPES.RETURNABLE_SCHEDULE_QUESTIONNAIRE_FILE_RESPONSE,
						question_id: Number(props?.name?.match(/\d+/g)), //abstract question id from question field name ( question_answer.question-question_id)
						rfq_id: rfxId,
						rfxInviteId: rfxInviteId,
					}}
					{...props}
					testId={`input-${props?.name}`}
					onDelete={onDeleteFile}
				/>
			</div>
		</div>
	);
};
